import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Icon from '../../../../components/Icon';
import { StyledRow, StyledMessage, StyledMessages, StyledType, StyledIconWrapper } from './styles';
import { getMessageStatuses } from '../../../../api';
var ExpandedMessage = function (_a) {
    var id = _a.id;
    var _b = useState([]), events = _b[0], setEvents = _b[1];
    useEffect(function () {
        getMessageStatuses(id).then(function (res) { return setEvents(res); });
    }, [id]);
    return (_jsxs(StyledRow, { children: [_jsx(StyledIconWrapper, { children: _jsx(Icon, { icon: "level-up-alt fa-rotate-90 fa-sm" }) }), _jsx(StyledMessages, { children: events.map(function (_a) {
                    var description = _a.description, type = _a.type;
                    return _jsxs(StyledMessage, { children: [_jsx(StyledType, { children: type }), _jsx("div", { children: description })] }, description);
                }) })] }));
};
export default ExpandedMessage;
